export default __webpack_public_path__ + "static/media/Ambassador-image.db5f7019.jpg";